import { render, staticRenderFns } from "./RegisterFromInvite.vue?vue&type=template&id=22c0d11b&"
import script from "./RegisterFromInvite.vue?vue&type=script&lang=js&"
export * from "./RegisterFromInvite.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports